/* Garage hero. The clip is a sprite-sheet frame sequence drawn on a canvas (a video element is
   only used when no sheets are set). Three ways to run it (the "Playback" setting):
   - opener: a full-screen overlay plays the clip once over the site (door opens, the car rolls out,
     the rev fires), then the overlay fades out and the page is there underneath: header, banner and
     the Year / Make / Model picker right under the header, with the car's final frame behind it.
     Once per visit by default; the sound button runs it again. Scrolling or a key press skips it.
   - auto: the clip plays in the hero on its own, then the page scrolls to the next section.
   - scrub: the clip follows the scroll. The section is a tall track with a sticky stage.
   Browsers refuse sound until the visitor's first tap, click or key press, so the rev waits for that
   gesture if the garage is still opening. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    var panelAt = parseFloat(getComputedStyle(section).getPropertyValue('--panel-at')) || 0.6;
    var mode = section.dataset.mode || 'scrub';
    var canvas = section.querySelector('[data-garage-canvas]');
    var video = section.querySelector('[data-garage-video]');
    var overlay = section.querySelector('[data-garage-opener]');
    var ovCanvas = overlay ? overlay.querySelector('[data-garage-opener-canvas]') : null;
    var frames = null;
    try { frames = section.dataset.frames ? JSON.parse(section.dataset.frames) : null; } catch (e) { frames = null; }
    /* Sharper sheets for wide screens when the section provides them (same grid and frame count) */
    var hd = null;
    try { hd = section.dataset.framesHd ? JSON.parse(section.dataset.framesHd) : null; } catch (e) { hd = null; }
    if (frames && hd && hd.sheets && hd.sheets.length && window.innerWidth >= 900) {
      frames = { sheets: hd.sheets, cols: frames.cols, rows: frames.rows, count: frames.count, w: hd.w || frames.w, h: hd.h || frames.h };
    }
    /* In opener mode the hero has no canvas of its own: the clip only lives in the overlay */
    var useFrames = !!(frames && frames.sheets && frames.sheets.length && (canvas || ovCanvas));
    var opener = mode === 'opener' && !reduceMotion && useFrames && !!ovCanvas;
    var auto = mode === 'auto' && !reduceMotion && ((useFrames && !!canvas) || !!video);
    var scrub = mode === 'scrub' && !reduceMotion && ((useFrames && !!canvas) || !!video);
    var timed = opener || auto;
    var autoDuration = (parseFloat(section.dataset.autoDuration) || 4) * 1000;
    var autoPause = (parseFloat(section.dataset.autoPause) || 0) * 1000;
    var autoScroll = section.dataset.autoScroll === 'true';
    var openerOnce = section.dataset.openerOnce === 'true';
    var seen = false;
    try { seen = openerOnce && sessionStorage.getItem('st_opener') === '1'; } catch (e) {}

    function setProgress(p) {
      progress = p;
      section.style.setProperty('--p', p.toFixed(4));
      var q = Math.min(Math.max((p - panelAt) / (1 - panelAt), 0), 1);
      q = q * q * (3 - 2 * q);
      section.style.setProperty('--q', q.toFixed(4));
      section.classList.toggle('is-panel', q > 0.5);
    }
    function showPanel() { section.classList.add('is-panel'); section.style.setProperty('--q', '1'); if (!scrub && !timed) section.style.setProperty('--p', '1'); }
    function collapse() { section.style.height = 'auto'; var st = section.querySelector('.garage-stage'); if (st) st.style.position = 'relative'; }
    function dropOverlay() { if (overlay) { overlay.classList.add('is-gone'); overlay.hidden = true; } section.classList.remove('is-opening'); }

    if (!useFrames && !video) { collapse(); showPanel(); dropOverlay(); return; }
    if (reduceMotion) { showPanel(); dropOverlay(); if (useFrames && canvas) drawStatic(); return; }
    if (mode === 'opener' && !opener) { showPanel(); dropOverlay(); if (useFrames && canvas) drawStatic(); return; }

    /* ---------- Scroll state (scrub) ---------- */
    var progress = 0, raf = null;
    var clipEnd = Math.min(1, panelAt + 0.12);
    function measure() {
      var rect = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      setProgress(total > 0 ? scrolled / total : 0);
    }
    function inView() { var r = section.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }

    /* ---------- Timed playback state (opener and auto) ---------- */
    var autoArmed = false, autoElapsed = 0, autoLast = 0, autoDone = false, autoReplay = false, userMoved = false, fading = false;
    /* The visitor took the wheel: never scroll the page for them, and let them past the opener */
    ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function (e) {
        if (ev === 'keydown' && !/^(Arrow|Page|Home|End|Escape| )/.test(e.key)) return;
        userMoved = true;
        if (opener && autoArmed && !autoDone) finishOpener();
      }, { passive: true, capture: true });
    });
    function nextSection() {
      var wrap = section.closest('.shopify-section') || section;
      var next = wrap.nextElementSibling;
      while (next && !next.offsetHeight) next = next.nextElementSibling;
      return next;
    }
    function scrollOn() {
      if (!autoScroll || userMoved || autoReplay || !inView()) return;
      var next = nextSection();
      if (!next) return;
      if (window.ST && ST.scrollTo) ST.scrollTo(next, 0); else next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    /* Overlay out, site in. Remembered for the rest of the visit. */
    function finishOpener(instant) {
      if (autoDone && !fading) return;
      autoDone = true; fading = false;
      try { if (openerOnce) sessionStorage.setItem('st_opener', '1'); } catch (e) {}
      if (!overlay) return;
      if (instant) { dropOverlay(); return; }
      /* two steps: the clip fades to the dark backdrop, then the backdrop fades and the store is there */
      overlay.classList.add('is-out');
      setTimeout(function () { if (overlay.classList.contains('is-out')) dropOverlay(); }, 3000);
    }
    function armAuto() {
      if (autoArmed) return;
      if (opener) {
        if (seen) { autoArmed = true; autoDone = true; autoElapsed = autoDuration; setProgress(1); paint(main, count - 1); finishOpener(true); return; }
        section.classList.add('is-opening');
      } else if (window.scrollY > window.innerHeight * 0.5) {
        /* Opened part way down the page (a reload, or a #fitment link): show the end state, no show, no scrolling */
        autoArmed = true; autoDone = true; autoElapsed = autoDuration; setProgress(1); paint(main, count - 1); return;
      }
      if (document.hidden) { document.addEventListener('visibilitychange', function once() { if (!document.hidden) { document.removeEventListener('visibilitychange', once); armAuto(); } }); return; }
      autoArmed = true; autoLast = 0;
    }
    /* Run it again from the closed door, with the rev. Used by the sound button once the show is over. */
    function replay() {
      autoReplay = true; autoDone = false; fading = false; autoElapsed = 0; autoLast = 0; armed = true; autoArmed = true;
      if (opener && overlay) {
        overlay.hidden = false; overlay.classList.remove('is-gone'); document.documentElement.classList.remove('st-opener-seen');
        paint(ov, 0);
        requestAnimationFrame(function () { overlay.classList.remove('is-out'); section.classList.add('is-opening'); });
        return;
      }
      if (window.ST && ST.scrollTo) ST.scrollTo(section, 0); else section.scrollIntoView({ behavior: 'smooth' });
      if (!useFrames && video) { try { video.currentTime = 0; video.play(); } catch (e) {} }
    }

    /* ---------- Sound. The clip is fetched up front, decoded and played through Web Audio, so the rev
       starts on the frame the door moves (an <audio> element adds start-up lag) and the quiet lead-in
       of the file is skipped. Browsers still refuse sound until the visitor's first tap, click or key
       press. Wheel and swipe scrolling do not count, so until then the rev waits and fires on that
       gesture if the garage is still opening. Re-arms at the top. The button mutes and unmutes. ---------- */
    var soundBtn = section.querySelector('[data-garage-sound]');
    var soundUrl = section.dataset.sound || '';
    var soundAuto = section.dataset.soundAuto === 'true';
    var AC = window.AudioContext || window.webkitAudioContext;
    var actx = null, bytes = null, buffer = null, voice = null, skip = 0, loading = false;
    var el = null, elPlay = 0, elOpen = false;
    var soundOn = false, armed = true, pending = false;
    var SOUND_AT = 0.05, SOUND_REARM = 0.01;
    function inRange() { return progress > SOUND_AT && (timed ? !autoDone : progress < clipEnd + 0.3); }
    function running() { return !!actx && actx.state === 'running'; }
    function retry() { if (pending && soundOn && inRange()) rev(); }
    /* Where the clip actually gets loud, less a short run-up */
    function leadIn(b) {
      var d = b.getChannelData(0), peak = 0, i, v;
      for (i = 0; i < d.length; i += 16) { v = d[i] < 0 ? -d[i] : d[i]; if (v > peak) peak = v; }
      for (i = 0; i < d.length; i += 4) { v = d[i] < 0 ? -d[i] : d[i]; if (v > peak * 0.25) break; }
      return Math.min(Math.max(0, i / b.sampleRate - 0.06), b.duration * 0.4);
    }
    /* Fallback for browsers without Web Audio, or if the fetch or decode fails */
    function useElement() {
      if (el) return;
      if (actx) { try { actx.close(); } catch (e) {} actx = null; }
      el = new Audio(soundUrl); el.preload = 'auto';
      retry();
    }
    function soundLoad() {
      if (loading || !soundUrl) return;
      loading = true;
      if (!AC || !window.fetch) { useElement(); return; }
      fetch(soundUrl).then(function (r) { if (!r.ok) throw new Error('sound'); return r.arrayBuffer(); })
        .then(function (ab) { bytes = ab; decode(); })
        .catch(useElement);
    }
    function soundCtx() {
      if (actx || el || !AC) return;
      try {
        /* Same as an <audio> element: play even when an iPhone's ringer switch is on silent */
        if (navigator.audioSession) navigator.audioSession.type = 'playback';
      } catch (e) {}
      try { actx = new AC(); actx.onstatechange = retry; decode(); } catch (e) { actx = null; useElement(); }
    }
    function decode() {
      if (!actx || !bytes || buffer) return;
      var ab = bytes; bytes = null;
      actx.decodeAudioData(ab, function (b) { buffer = b; skip = leadIn(b); retry(); }, useElement);
    }
    function wake() {
      if (!actx || actx.state === 'running') return;
      var p = actx.resume();
      if (p && p.then) p.then(retry, function () {});
    }
    function rev() {
      pending = false;
      if (!el) { soundLoad(); soundCtx(); }
      if (el) {
        var id = ++elPlay;
        el.muted = false;
        try { el.currentTime = 0; } catch (e) {}
        var p = el.play();
        if (p && p.then) p.then(function () { elOpen = true; }, function () { if (id === elPlay) pending = true; });
        return;
      }
      if (!buffer || !running()) { pending = true; wake(); return; }
      hush(0.05);
      var t = actx.currentTime, g = actx.createGain(), s = actx.createBufferSource();
      g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(1, t + 0.04);
      s.buffer = buffer; s.connect(g); g.connect(actx.destination);
      s.onended = function () { if (voice && voice.s === s) voice = null; try { g.disconnect(); } catch (e) {} };
      s.start(t, skip);
      voice = { s: s, g: g };
    }
    function hush(sec) {
      if (el) { elPlay++; if (!el.paused) el.pause(); return; }
      if (!voice) return;
      var v = voice, t = actx.currentTime; voice = null; sec = sec || 0.28;
      try { v.g.gain.cancelScheduledValues(t); v.g.gain.setValueAtTime(v.g.gain.value, t); v.g.gain.linearRampToValueAtTime(0, t + sec); v.s.stop(t + sec + 0.02); } catch (e) {}
    }
    /* Any tap, click or key press unlocks sound. Kept attached: phones suspend audio again after a call or a tab switch. */
    function onGesture() {
      if (!soundOn || !soundUrl) return;
      if (!el) { soundLoad(); soundCtx(); }
      if (!el) { wake(); return; }
      if (pending && inRange()) { rev(); return; }
      if (elOpen) return;
      elOpen = true;
      var id = elPlay; el.muted = true;
      var p = el.play();
      if (p && p.then) p.then(function () { if (id === elPlay) { el.pause(); try { el.currentTime = 0; } catch (e) {} } el.muted = false; }, function () { el.muted = false; elOpen = false; });
    }
    ['pointerdown', 'pointerup', 'touchend', 'click', 'keydown'].forEach(function (ev) { document.addEventListener(ev, onGesture, { capture: true, passive: true }); });
    function setSound(on) {
      soundOn = on;
      if (soundBtn) soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      try { sessionStorage.setItem('st_sound', on ? '1' : '0'); } catch (e) {}
      if (on) {
        soundLoad(); soundCtx(); wake();
        if (timed && autoDone) { replay(); return; }
        if (inRange()) { armed = false; rev(); }
      }
      else { pending = false; hush(); }
    }
    if (soundUrl) {
      var stored = null; try { stored = sessionStorage.getItem('st_sound'); } catch (e) {}
      soundOn = stored === '1' || (stored !== '0' && soundAuto);
      if (soundBtn) soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      if (soundOn) soundLoad();
      if (soundBtn) soundBtn.addEventListener('click', function () { setSound(!soundOn); });
    }
    function soundTick() {
      if (!soundOn || !soundUrl) return;
      if (armed && progress > SOUND_AT) { armed = false; rev(); }
      else if (!armed && progress < SOUND_REARM) { armed = true; pending = false; hush(); }
    }

    /* ---------- Engine 1: sprite sheet frames on a canvas. Two targets: the hero's own canvas
       (main) and, in opener mode, the overlay's canvas (ov) that plays the clip. ---------- */
    var sheets = [], loaded = [], count = 0, cols = 4, rows = 4, fw = 960, fh = 540, perSheet = 16;
    var fIndex = 0, fTarget = 0;
    var main = { el: canvas, ctx: null, cw: 0, ch: 0, dpr: 1, last: -1 };
    var ov = { el: ovCanvas, ctx: null, cw: 0, ch: 0, dpr: 1, last: -1 };
    var stage = opener ? ov : main;
    function sizeCanvas(T) {
      if (!T.el) return;
      T.dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      T.cw = T.el.clientWidth || window.innerWidth; T.ch = T.el.clientHeight || window.innerHeight;
      T.el.width = Math.round(T.cw * T.dpr); T.el.height = Math.round(T.ch * T.dpr);
      T.last = -1;
    }
    function paint(T, i) {
      if (!T.ctx) return;
      i = Math.max(0, Math.min(count - 1, Math.round(i)));
      var s = Math.floor(i / perSheet), k = i % perSheet;
      /* fall back to the latest earlier frame whose sheet has arrived */
      while (s >= 0 && !loaded[s]) { s--; k = perSheet - 1; }
      if (s < 0) return;
      var img = sheets[s];
      var sx = (k % cols) * fw, sy = Math.floor(k / cols) * fh;
      var scale = Math.max(T.cw / fw, T.ch / fh);
      var dw = fw * scale, dh = fh * scale, dx = (T.cw - dw) / 2, dy = (T.ch - dh) / 2;
      T.ctx.setTransform(T.dpr, 0, 0, T.dpr, 0, 0);
      T.ctx.drawImage(img, sx, sy, fw, fh, dx, dy, dw, dh);
      T.last = s * perSheet + k;
    }
    function drawStatic() { if (!useFrames) return; initFrames(function () { fIndex = count - 1; paint(main, fIndex); }); }
    function initFrames(onFirst) {
      if (main.ctx) return;
      [main, ov].forEach(function (T) {
        if (!T.el) return;
        T.ctx = T.el.getContext('2d');
        T.ctx.imageSmoothingEnabled = true; T.ctx.imageSmoothingQuality = 'high';
      });
      cols = frames.cols || 4; rows = frames.rows || 4; fw = frames.w || 960; fh = frames.h || 540;
      perSheet = cols * rows; count = frames.count || frames.sheets.length * perSheet;
      sizeCanvas(main); sizeCanvas(ov);
      window.addEventListener('resize', function () { sizeCanvas(main); sizeCanvas(ov); paint(stage, fIndex); if (opener) paint(main, count - 1); });
      frames.sheets.forEach(function (url, n) {
        var img = new Image();
        img.decoding = 'async';
        /* the show cannot start until sheet 0 is in, so it wins the bandwidth */
        try { img.fetchPriority = n === 0 ? 'high' : 'low'; } catch (e) {}
        img.onload = function () {
          loaded[n] = true; sheets[n] = img;
          if (n === 0) { stage.el.classList.add('is-ready'); if (onFirst) onFirst(); paint(stage, fIndex); }
          else if (stage.last < 0 || Math.floor(fIndex / perSheet) === n) paint(stage, fIndex);
          /* the hero behind the opener holds the last frame; it stays on the poster until that sheet is in */
          if (opener && main.el && Math.floor((count - 1) / perSheet) === n) { paint(main, count - 1); main.el.classList.add('is-ready'); }
        };
        img.onerror = function () { if (n === 0 && video) { useFrames = false; if (canvas) canvas.hidden = true; dropOverlay(); initVideo(); } };
        /* first sheet now, the rest right behind it (all at once when the clip plays on its own) */
        if (n === 0 || timed) img.src = url; else setTimeout(function () { img.src = url; }, 150 * n);
      });
    }

    /* ---------- Engine 2: video currentTime ---------- */
    var vReady = false, duration = 0, vCurrent = 0, lastSeek = 0;
    function initVideo() {
      if (!video) return;
      function onReady() {
        if (vReady) return; vReady = true; duration = video.duration || 0; video.classList.add('is-ready');
        if (auto) { armAuto(); if (autoArmed && !autoDone) { try { video.currentTime = 0; video.play(); } catch (e) {} } return; }
        video.pause(); try { video.currentTime = 0.001; } catch (e) {}
      }
      video.addEventListener('loadedmetadata', onReady);
      video.addEventListener('canplay', onReady);
      video.addEventListener('error', function () { if (!vReady && !useFrames) { collapse(); showPanel(); } });
      if (video.readyState >= 1) onReady();
      document.addEventListener('visibilitychange', function () { if (!document.hidden && !vReady) { try { video.load(); } catch (e) {} } });
      setTimeout(function () { if (!vReady && !document.hidden) { try { video.load(); } catch (e) {} } }, 4000);
    }

    if (useFrames) initFrames(timed ? armAuto : null); else initVideo();
    if (opener) showPanel();
    if (!scrub && !timed) { showPanel(); return; }

    /* ---------- The loops ---------- */
    function tickScrub() {
      raf = requestAnimationFrame(tickScrub);
      if (!inView()) { if (soundOn) hush(); return; }
      measure();
      soundTick();
      var t = Math.min(progress / clipEnd, 1);
      if (useFrames) {
        fTarget = t * (count - 1);
        fIndex += (fTarget - fIndex) * 0.22;
        if (Math.abs(fTarget - fIndex) < 0.05) fIndex = fTarget;
        if (Math.round(fIndex) !== main.last) paint(main, fIndex);
      } else if (vReady) {
        var target = t * Math.max(duration - 0.06, 0);
        vCurrent += (target - vCurrent) * 0.16;
        if (Math.abs(target - vCurrent) < 0.004) vCurrent = target;
        var now = performance.now();
        if (!video.seeking && now - lastSeek > 24 && Math.abs(video.currentTime - vCurrent) > 0.012) { lastSeek = now; try { video.currentTime = vCurrent; } catch (e) {} }
      }
    }
    /* Plays once on a clock. The frame engine runs the clock; the video engine follows the video's own time. */
    function tickTimed(now) {
      raf = requestAnimationFrame(tickTimed);
      if (!autoArmed || autoDone) return;
      var t;
      if (useFrames) {
        if (autoLast) autoElapsed += now - autoLast;
        autoLast = now;
        t = Math.min(autoElapsed / autoDuration, 1);
        fIndex = t * (count - 1);
        if (Math.round(fIndex) !== stage.last) paint(stage, fIndex);
      } else {
        if (!vReady) return;
        t = duration > 0 ? Math.min(video.currentTime / Math.max(duration - 0.06, 0.01), 1) : 0;
      }
      if (opener) { progress = t; section.style.setProperty('--p', t.toFixed(4)); } else setProgress(t);
      soundTick();
      if (t >= 1) {
        if (opener) { fading = true; autoDone = true; setTimeout(function () { finishOpener(); }, autoPause); }
        else { autoDone = true; setTimeout(scrollOn, autoPause); }
      }
    }
    var tick = timed ? tickTimed : tickScrub;
    raf = requestAnimationFrame(tick);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { hush(0.1); autoLast = 0; if (raf) { cancelAnimationFrame(raf); raf = null; } }
      else if (!raf) raf = requestAnimationFrame(tick);
    });
  }

  function scan() { document.querySelectorAll('[data-garage]').forEach(setup); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
